export const ACCEPT = { label: 'Accept', value: 'ACCEPT' };
export const REJECT = { label: 'Reject', value: 'REJECT' };
export const COMPLETE = {
  label: 'Mark Delivered',
  value: 'COMPLETE',
};
export const SEND_RECEIPT = { label: 'Resend Receipt', value: 'SEND_RECEIPT' };
export const SHIP = { label: 'Ship', value: 'SHIP' };

export const ORDER_STATUS_OPTIONS = [
  { value: 'accepted', label: 'Accepted' },
  { value: 'completed', label: 'Completed' },
  { value: 'pending', label: 'Pending' },
  { value: 'pending_payment', label: 'Pending Payment' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'shipped', label: 'Shipped' },
];

export const ORDER_DATE_OPTIONS = [
  { value: 30, label: 'Last 30 Days' },
  { value: 60, label: 'Last 60 Days' },
  { value: 90, label: 'Last 90 Days' },
];
